import { Box, VStack } from '@chakra-ui/react'
import { Button } from 'uikit'
import { Field, Formik } from 'formik'
import moment from 'moment/moment'
import { SelectForm } from 'uikit'
import { InputDateForm } from 'uikit/FormStateComponents/InputDateForm'
import { Form } from 'uikit/layout'
import * as Yup from 'yup'
import { reportTypeOptions } from '../Reports.constants'

const formSchema = Yup.object({
  type: Yup.string().required('Не заполнен тип'),
  date: Yup.object({
    from: Yup.date()
      .typeError('Некорректная дата "от"')
      .required('Не выбрана дата "от"')
      .nullable(),
    to: Yup.date()
      .typeError('Некорректная дата "до"')
      .required('Не выбрана дата "до"')
      .test('3 month more', 'Диапазон больше 3 месяцев недопустим', async (value, context) => {
        const momentFrom = moment(context.parent.from).add(1, 'd')
        const momentTo = moment(value)
        const diff = momentTo.diff(momentFrom, 'month')

        return diff < 3
      })
      .test('to_limit', 'Конец диапазона не должен превышать начало', async (value, context) => {
        if (value === undefined) return false

        return value >= context.parent.from
      })
      .nullable(),
  }),
})

type Props = {
  onSubmit: (values: ReportValues) => void
  isLoading: boolean
}

export const ReportsMutate: React.FC<Props> = ({ onSubmit, isLoading }) => {
  return (
    <Formik enableReinitialize initialValues={{}} onSubmit={onSubmit} validationSchema={formSchema}>
      {(props) => {
        return (
          <Form onSubmit={props.handleSubmit}>
            <VStack gap="20px">
              <Field
                name="type"
                component={SelectForm}
                label="Тип"
                placeholder="Выберите тип"
                options={reportTypeOptions}
                disabled={isLoading}
                isClearable
              />

              <Field
                disabled={isLoading}
                name="date"
                label="Дата"
                placeholder="Выберите диапазон"
                component={InputDateForm}
                withDialog
                dayPickerProps={{
                  disabledDays: {
                    after: moment().add(-1, 'd').toDate(),
                  },
                }}
                isRangePick
              />
            </VStack>

            <Box pt="30px">
              <Button type="submit" colorPalette="orange" loading={isLoading}>
                Отправить
              </Button>
            </Box>
          </Form>
        )
      }}
    </Formik>
  )
}

export type ReportValues = {
  type?: string
  date?: {
    from?: string
    to?: string
  }
}
